import { Pipe, PipeTransform } from '@angular/core';
import { Store } from '@ngxs/store';
import { DirectoryColumn } from 'src/app/samwebDescription/samweb/directory/directory-column';
import { DirectoryStructureState } from 'src/app/store/samwin/directory/directory-structure/directory-structure.state';

@Pipe({
   name: 'directoryColumnOrganisationUnit',
})
export class DirectoryColumnOrganisationUnitPipe implements PipeTransform {
   constructor(public store: Store) {}

   transform(directoryColumn: DirectoryColumn): string {
      if (!directoryColumn.columnTyp.isOrganisation) {
         return directoryColumn.organisationUnitName;
      }
      const key = directoryColumn.columnTyp.enumName.slice(-2);
      return this.store.selectSnapshot(DirectoryStructureState.getStructureNameForStructureNumber)(key);
   }
}
